export const APPLE_REVIEWER_ACCOUNT = {
  username: 'apple_reviewer_demo',
  privateKey:
    '0x05e63bfebee290ac2502961b12f07dc976a753367a47beff4509026bf29c6849',
  credentialId: '33e708b5-6710-42fa-a64f-eb1b0391c58e ',
};
